import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CtaProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'text';
  showArrow?: boolean;
  fullWidth?: boolean;
}
export function Cta({
  children,
  variant = 'primary',
  showArrow = false,
  fullWidth = false,
  className = '',
  ...props
}: CtaProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold transition-all rounded-xl';
  const variants = {
    primary: 'bg-[#d4a574] hover:bg-[#c89860] text-white px-8 py-4 text-lg shadow-md hover:shadow-lg hover:-translate-y-0.5',
    secondary: 'bg-white border-2 border-[#1a2838] text-[#1a2838] hover:bg-[#f5f3f0] px-8 py-4 text-lg',
    text: 'bg-transparent text-[#1a2838] hover:text-[#8ba89f] p-0 text-lg underline underline-offset-4 decoration-[#8ba89f]/40 hover:decoration-[#8ba89f]'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-106" data-mp="1ie3eg3pih95t">
      {children}
      {showArrow && <ArrowRight className="ml-2.5 h-5 w-5" data-id="element-107" data-mp="18qiezdagyjgo" />}
    </button>;
}